import { styled } from '@slal/ui';

interface WrapperProps {
    type?: 'info' | 'warning' | 'error';
}

export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    gap: 8px;
    padding: 16px;
    border-radius: 8px;
    background-color: ${({ type }) => {
        switch (type) {
            case 'warning':
                return '#ff9800';
            case 'error':
                return '#f44336';
            case 'info':
            default:
                return '#EFF6FA';
        }
    }};
`;

export const IconWrapper = styled.div`
    width: 24px;
    height: 24px;
`;
